// components
import ChatThread from '@corefront/components-v2/Chat/ChatThread';
import DoctorPatientChatBubble from '@/components/chat/DoctorPatientChatBubble';

// mixins
import { chatThread } from '@corefront/mixins-v2/chatThread';
import { mapState } from 'vuex';
export default {
  components: {
    ChatThread,
    DoctorPatientChatBubble
  },
  mixins: [chatThread],
  props: {
    isMessagesLoaded: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('chat', ['selectedConversation', 'nextPage', 'messages']),
    ...mapState('doctors', ['doctors'])
  },
  async mounted() {
    await this.$store.dispatch('doctors/getAllDoctors');
  },
  methods: {
    getSenderName(message) {
      if (message.userid === this.selectedConversation.patient.id) {
        return `${this.selectedConversation.patient.firstname} ${this.selectedConversation.patient.lastname}`;
      } else {
        const doctor = this.doctors.find(doc => doc.id === message.userid);
        return doctor ? `Dr. ${doctor.firstname} ${doctor.lastname}` : '';
      }
    },
    async messageScroll($state) {
      if (!this.nextPage || this.loadingMessage) {
        return;
      }
      try {
        this.loadingMessage = true;
        const nextPageCursor = await this.$store.dispatch('chat/fetchDoctorPatientMessages', {
          conversationid: this.selectedConversation.id,
          nextpage: this.nextPage
        });
        if (nextPageCursor) {
          $state.loaded();
        } else {
          $state.complete();
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.loadingMessage = false;
      }
    }
  }
};